import { parse, format, endOfDay } from 'date-fns';

import { ISO_FORMAT } from '../components';

export const getEndOfDay = (date: string, dateFormat = ISO_FORMAT) => {
  if (!date) return '';

  const parsedDate = parse(date, dateFormat, new Date());
  const end = endOfDay(parsedDate);
  return format(end, dateFormat);
};
